import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, branch } from 'recompose';

import withCost from './withCost';
import withCostWithoutFees from './withCostWithoutFees';
import OrderInformation from '../components/OrderInformation';
import sharedContainer from './OrderInformationSharedContainer';
import { getNoExtrasForReserveNoPay } from '../../shops/selectors';
import WithApplePayQuery from '../../hoc/WithApplePayQuery';
import WithTimeWaitingList from '../../hoc/WithTimeWaitingList';

const withCostHOC = compose(
  WithTimeWaitingList,
  branch(
    props => props.showOnlyCostAndTaxes,
    withCostWithoutFees,
    withCost,
  )
);

export default compose(
  withRouter,
  WithApplePayQuery,
  connect((state, ownProps) => {
    const noExtrasForReserveNoPay = getNoExtrasForReserveNoPay(state, ownProps.params.shopRoute);

    return {
      noExtrasForReserveNoPay,
      showOnlyCostAndTaxes: noExtrasForReserveNoPay && !ownProps.withApplePay,
    };
  }, null),
  withCostHOC,
  sharedContainer,
)(OrderInformation);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/OrderInformation.js